import Toast from './Toast.svelte';
export function open(props) {
    if (typeof props === 'string')
        props = { message: props };
    new Toast({
        target: document.body,
        props,
        intro: true,
    });
}
function openType(type) {
    return (options) => {
        const props = {
            type,
            message: '',
        };
        if (typeof options === 'string')
            props.message = options;
        else
            Object.assign(props, options);
        new Toast({
            target: document.body,
            props,
            intro: true,
        });
    };
}
export const info = openType('secondary');
export const success = openType('success');
export const warning = openType('warning');
export const warn = warning;
export const danger = openType('danger');
export const error = danger;
Object.assign(Toast, {
    open, info, success, warning, warn, error, danger
});
export default Toast;
